import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon, Url } from '#const';
import { getIconUrl } from '#utils';

const IconList = dynamic(() => import('./IconList'));

Builder.registerComponent(IconList, {
	name: 'IconList',
	inputs: [
		{
			name: 'heading',
			friendlyName: 'Heading',
			type: 'richText',
			required: true,
			defaultValue: '<h2>Icon List</h2>',
		},
		{
			name: 'listItems',
			friendlyName: 'List Items',
			type: 'list',
			copyOnAdd: true,
			subFields: [
				{
					name: 'icon',
					friendlyName: 'Icon',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
					required: false,
					defaultValue: Url.PLACEHOLDER,
				},
				{
					name: 'text',
					friendlyName: 'Text',
					type: 'richText',
					required: true,
					defaultValue: '<p>Placeholder text.</p>',
				},
			],
			defaultValue: [
				{
					icon: Url.PLACEHOLDER,
					text: '<p>Placeholder text.</p>',
				},
			],
		},
		{
			name: 'secondaryHeroLoc',
			friendlyName: 'Show In Secondary Hero Location',
			type: 'boolean',
			defaultValue: false,
		},
	],
	image: getIconUrl(Icon.IMAGE_TEXT_SECTION),
});
